import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from 'app/app.component';
import { LoginRegisterComponent } from 'app/login-register/login-register.component';
import { ResetPasswordComponent } from 'app/reset-password/reset-password.component';
import { ConfirmEmailComponent } from 'app/confirm-email/confirm-email.component';
import { SamlLoginComponent } from 'app/saml-login/saml-login.component';
import { LogoutComponent } from 'app/logout/logoutcomponent';

export const PUBLIC_ROUTES: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    { path: 'login', component: LoginRegisterComponent},
    { path: 'resetPassword', component: ResetPasswordComponent},
    { path: 'confirm_email', component: ConfirmEmailComponent},
    { path: 'saml_login', component: SamlLoginComponent},
    { path: 'logout', component: LogoutComponent},
];

